export class StringManipulator {
    private readonly initialText: string;

    public text;

    private readonly newKey: string;

    constructor(text: string, newKey: string) {
        this.text = text;
        this.newKey = newKey;
        this.initialText = text;
    }

    public replaceCharAt(char: string, index: number): this {
        this.text = `${this.text.substring(0, index)}${char}${this.text.substring(index + 1)}`;
        return this;
    }

    public replaceNewCharAt(index: number): this {
        this.replaceCharAt(this.newKey, index);
        return this;
    }

    public insertCharAt(char: string, index: number): this {
        this.text = `${this.text.substring(0, index)}${char}${this.text.substring(
            index,
            this.text.length,
        )}`;
        return this;
    }

    public insertNewCharAt(index: number): this {
        this.insertCharAt(this.newKey, index);
        return this;
    }

    public removeCharAt(index: number): this {
        this.text = `${this.text.substring(0, index)}${this.text.substring(index + 1)}`;
        return this;
    }

    public cutTail(): this {
        this.text = this.text.substring(0, this.text.length - 1);
        return this;
    }

    public reset(): this {
        this.text = this.initialText;
        return this;
    }
}
